module.exports = __webpack_public_path__ + "static/img/earn-big.5d944a14.webp";